
import Vue, { PropType } from 'vue'
import type { RawLocation } from 'vue-router'

import { hasSlot, normalizeSlot } from '@/util'

export default Vue.extend({
  name: 'SidebarSectionHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    to: {
      type: Object as PropType<RawLocation>,
      default: null,
    },
  },
  methods: {
    hasSlot,
    normalizeSlot,
  },
  render(h) {
    let content = h(
      'span',
      {
        staticClass: 'inline-flex items-center',
        class: { 'text-neutral-7': this.to === null },
      },
      [
        h(
          'span',
          {
            class: { 'mr-2': this.expanded },
            staticClass: 'sidebar-section__icon',
          },
          [this.normalizeSlot('icon')]
        ),
        h(
          'span',
          {
            class: {
              'text-xs': this.expanded === false,
              'text-lg font-medium': this.expanded,
            },
          },
          this.title
        ),
      ]
    )

    return h(
      'div',
      {
        staticClass:
          'sidebar-section__header relative flex items-center shrink-0 pl-1 pr-2',
      },
      [
        h(
          'div',
          {
            class: {
              'flex-col w-full': this.expanded === false,
              'pl-8': this.hasSlot('chevron') === false && this.expanded,
            },
            staticClass: 'flex items-center w-full',
          },
          [
            this.normalizeSlot('chevron'),
            this.to !== null
              ? h(
                  'router-link',
                  {
                    props: { to: this.to },
                    staticClass: 'text-neutral-7 no-underline',
                  },
                  [content]
                )
              : content,
            h(
              'div',
              { staticClass: 'relative z-1 ml-auto' },
              this.normalizeSlot('controls')
            ),
          ]
        ),
      ]
    )
  },
})
